import request from '@/utils/request'
import type * as Pipeline from '@/typings/pipeline'
import type * as projectType from '@/typings/project'
import type { CommonRes, ISystemAccount } from '@/typings'
import type {
  IConvertibleBondRemark,
  IConvertibleBondSummary,
  IPipelineInfoType,
  IProjectReceiptItem
} from '@/typings/pipeline'
import type { YesOrNo } from '@/constants'
import type { IProjectReceiptSave } from '@/typings/pipeline'
import type { IProjectPaymentSave } from '@/typings/pipeline'

interface IEnterPipelineParams {
  ts: Pipeline.PipelineBaseInfoType
}
// 进入Pipeline（状态）
export async function enterPipeline(params: IEnterPipelineParams) {
  return request('/api/v2/project/pipeline/enter', {
    method: 'post',
    data: params
  })
}

interface IAddMemoPaymentParams {
  payment: IProjectPaymentSave
}
// Memo详情 - 打款区 - 申请打款
export async function addMemoPayment(params: IAddMemoPaymentParams) {
  return request('/api/v2/project/pipeline/payment/add', {
    method: 'post',
    data: params
  })
}
// Memo详情 - 打款区 - 编辑申请
export async function editMemoPayment(params: IAddMemoPaymentParams) {
  return request('/api/v2/project/pipeline/payment/update', {
    method: 'post',
    data: params
  })
}

interface IOpenSpaParams {
  memo_id: number
}
// Memo详情 - SPA区 - 申请签字
export async function openSpa(params: IOpenSpaParams) {
  return request('/api/v2/project/pipeline/spa/open', {
    method: 'post',
    data: params
  })
}

// Memo详情 - SPA区 - 更新
export async function updateSpa(params: Pipeline.SpaInfoType) {
  return request('/api/v2/project/pipeline/spa/update', {
    method: 'post',
    data: params
  })
}
interface IUpdateConvertibleBondParams {
  attachment_file_ids?: string[]
  convertible_bond_id?: number
  convertible_bond_remark?: IConvertibleBondRemark[]
  convertible_bond_summary?: IConvertibleBondSummary[]
  is_convertible_bond?: number
  is_hide_summary_ts_value?: number
  is_submit?: boolean
}
// Memo详情 - 可转债区 - 更新
export async function apiUpdateConvertibleBond(params: IUpdateConvertibleBondParams) {
  return request('/api/v2/project/pipeline/convertible_bond/update', {
    method: 'post',
    data: params
  })
}
interface IDeleteSpaParams {
  spa_id: number
}
// Memo详情 - SPA区 - 删除
export async function deleteSpa(params: IDeleteSpaParams) {
  return request('/api/v2/project/pipeline/spa/delete', {
    method: 'post',
    data: params
  })
}

interface IConfirmSpaParams {
  spa_id: number
}
// Memo详情 - SPA区 - sponsorConfirm
export async function confirmSpa(params: IConfirmSpaParams) {
  return request('/api/v2/project/pipeline/spa/confirm', {
    method: 'post',
    data: params
  })
}
// Memo详情 - 可转债区 - sponsorConfirm
export async function confirmConvertibleBond(params: { convertible_bond_id: number }) {
  return request('/api/v2/project/pipeline/convertible_bond/confirm', {
    method: 'post',
    data: params
  })
}
interface IPmConfirmSpaParams {
  spa_id: number
}
// Memo详情 - SPA区 - pmConfirm
export async function pmConfirmSpa(params: IPmConfirmSpaParams) {
  return request('/api/v2/project/pipeline/spa/pm_confirm', {
    method: 'post',
    data: params
  })
}
// Memo详情 - 可转债区 - pmConfirm
export async function pmConfirmConvertibleBond(params: { convertible_bond_id: number }) {
  return request('/api/v2/project/pipeline/convertible_bond/pm_confirm', {
    method: 'post',
    data: params
  })
}

interface IRollbackSpaParams {
  spa_id: number
}
// Memo详情 - SPA区 - 撤回Confirm
export async function rollbackSpa(params: IRollbackSpaParams) {
  return request('/api/v2/project/pipeline/spa/rollback', {
    method: 'post',
    data: params
  })
}
// Memo详情 - 可转债区 - 撤回Confirm
export async function rollbackConvertibleBond(params: { convertible_bond_id: number }) {
  return request('/api/v2/project/pipeline/convertible_bond/rollback', {
    method: 'post',
    data: params
  })
}
interface IUpdatePipelineRequest {
  ts: Pipeline.PipelineBaseInfoType
}
// Memo详情 - 编辑Pipeline
export async function updatePipeline(params: IUpdatePipelineRequest) {
  return request('/api/v2/project/pipeline/update', {
    method: 'post',
    data: params
  })
}

interface IGetProjectPipelineInfoParams {
  memo_id: number
  project_id: number
}
// 项目详情获取pipeline数据
export async function getProjectPipelineInfo(params: IGetProjectPipelineInfoParams) {
  return request<CommonRes<IPipelineInfoType>>('/api/v2/project/pipeline/get', {
    method: 'get',
    data: params
  })
}

// 合伙人Pipeline
export async function getPartnerPipelineList(params: any) {
  return request('/api/v2/project/pipeline/partner_search', {
    method: 'post',
    data: params
  })
}
interface IAddPipelineSpaRemarkParams {
  spa_id: number
  remark: string
}
// 项目详情pipeline交易文件区添加补充说明
export async function addPipelineSpaRemark(params: IAddPipelineSpaRemarkParams) {
  return request('/api/v2/project/pipeline/spa/remark_add', {
    method: 'post',
    data: params
  })
}
interface IAddPipelineConvertibleBondRemarkParams {
  convertible_bond_id: number
  remark: string
}
export async function addPipelineConvertibleBondRemark(
  params: IAddPipelineConvertibleBondRemarkParams
) {
  return request('/api/v2/project/pipeline/convertible_bond/remark_add', {
    method: 'post',
    data: params
  })
}
// 后台Pipeline
export async function getBackPipelineList(params: any) {
  return request('/api/v2/project/pipeline/back_search', {
    method: 'post',
    data: params
  })
}
interface IDelPipelineSpaRemarkParams {
  spa_remark_id: number
}
// 项目详情pipeline交易文件区添加补充说明
export async function delPipelineSpaRemark(params: IDelPipelineSpaRemarkParams) {
  return request('/api/v2/project/pipeline/spa/remark_delete', {
    method: 'post',
    data: params
  })
}

// 项目详情pipeline交易文件区添加可转债
export async function delPipelineConvertibleBondRemark(params: {
  convertible_bond_remark_id: number
}) {
  return request('/api/v2/project/pipeline/convertible_bond/remark_delete', {
    method: 'post',
    data: params
  })
}

// CFOPipeline
export async function getCfoPipelineList(params: any) {
  return request('/api/v2/project/pipeline/comfirm_search', {
    method: 'post',
    data: params
  })
}
interface IUpdatePipelineSpaRemarkParams {
  spa_remark_id: number
  remark: string
}
// 项目详情pipeline交易文件区添加补充说明
export async function updatePipelineSpaRemark(params: IUpdatePipelineSpaRemarkParams) {
  return request('/api/v2/project/pipeline/spa/remark_update', {
    method: 'post',
    data: params
  })
}

interface IUpdatePipelineConvertibleBondParams {
  convertible_bond_remark_id: number
  remark: string
}
// 项目详情pipeline交易文件区添加补充说明
export async function updatePipelineConvertibleBondRemark(
  params: IUpdatePipelineConvertibleBondParams
) {
  return request('/api/v2/project/pipeline/convertible_bond/remark_update', {
    method: 'post',
    data: params
  })
}

// Memo详情 - 打款区 - 完成打款
export async function memoFinancePayment(params: projectType.IPaymentConfirm) {
  return request('/api/v2/project/pipeline/payment/finance_confirm', {
    method: 'post',
    data: params
  })
}

interface IOpenPipelineSpaParams {
  memo_id: number
}
// 开启打款
export async function openPipelineSpa(params: IOpenPipelineSpaParams) {
  return request('/api/v2/project/pipeline/payment/open', {
    method: 'post',
    data: params
  })
}

interface IDropRollbackRequest {
  drop_level?: number
  memo_id?: number
}
// Memo详情 - Drop撤回
export async function dropRollback(params: IDropRollbackRequest) {
  return request('/api/v2/project/pipeline/drop_rollback', {
    method: 'post',
    data: params
  })
}
// 开启可转债
export async function apiOpenPipelineConvertibleBond(params: { memoId: number }) {
  return request('/api/v2/project/pipeline/convertible_bond/open', {
    method: 'post',
    data: params
  })
}
interface IGetPipelineLegalFinanceRequest {
  memo_id: number
}
// Memo-获取项目Memo
export async function getPipelineLegalFinance(params: IGetPipelineLegalFinanceRequest) {
  return request<CommonRes<{ legal_list: ISystemAccount[]; finance_list: ISystemAccount[] }>>(
    '/api/v2/project/pipeline/legal_finance_get',
    {
      method: 'GET',
      data: params
    }
  )
}
/** 选择法务财务 */
export interface IUpdatePipelineLegalFinanceParams {
  finance_uids?: number[]
  legal_uids?: number[]
  memo_id?: number
}

export async function apiUpdatePipelineLegalFinance(params: IUpdatePipelineLegalFinanceParams) {
  return request<CommonRes<{ has_permission: YesOrNo }>>(
    '/api/v2/project/pipeline/legal_finance_update',
    {
      method: 'POST',
      data: params
    }
  )
}

export interface IAddPipelineReceiptParams {
  receipt: IProjectReceiptSave
}

export async function apiAddPipelineReceipt(params: IAddPipelineReceiptParams) {
  return request('/api/v2/project/pipeline/receipt/add', {
    method: 'POST',
    data: params
  })
}
export interface IUpdatePipelineReceiptItemParams {
  receipt_item: IProjectReceiptItem
}

export async function apiUpdatePipelineReceiptItem(params: IUpdatePipelineReceiptItemParams) {
  return request('/api/v2/project/pipeline/receipt/item_update', {
    method: 'POST',
    data: params
  })
}
export interface IFinanceConfirmReceiptParams {
  receipt: {
    id?: number
  }
  /** issue 115：部分交割时「已完成此次交易的所有收款，进入已交割」（从记录收款弹窗挪到完成收款） */
  is_complete_all_receipt?: number
}
export async function apiFinanceConfirmReceipt(params: IFinanceConfirmReceiptParams) {
  return request('/api/v2/project/pipeline/receipt/finance_confirm', {
    method: 'POST',
    data: params
  })
}
// ---- issue 115 / ADR-110：收款区结构化 ----
export interface IUpdatePipelineReceiptParams {
  receipt: Pipeline.IProjectReceiptSave
}
/** PM 修改收款信息（财务记第一笔前） */
export async function apiUpdatePipelineReceipt(params: IUpdatePipelineReceiptParams) {
  return request('/api/v2/project/pipeline/receipt/update', {
    method: 'POST',
    data: params
  })
}
export interface IAddPipelineReceiptRecordParams {
  record: Pipeline.IProjectReceiptRecordSave
}
/** 财务记录收款：对某笔计划提交一批（可多次） */
export async function apiAddPipelineReceiptRecord(params: IAddPipelineReceiptRecordParams) {
  return request('/api/v2/project/pipeline/receipt/record/add', {
    method: 'POST',
    data: params
  })
}
/** 财务删除自己记录的一批（完成收款前） */
export async function apiDeletePipelineReceiptRecord(params: { id: number }) {
  return request('/api/v2/project/pipeline/receipt/record/delete', {
    method: 'POST',
    data: params
  })
}
export interface IConvertibleBondSponsorRollbackParams {
  convertible_bond_id?: number
  convertible_bond_status?: number
}
export async function apiConvertibleBondSponsorRollback(
  params: IConvertibleBondSponsorRollbackParams
) {
  return request('/api/v2/project/pipeline/convertible_bond/sponsor_rollback', {
    method: 'POST',
    data: params
  })
}
export interface IDDPlanRollbackParams {
  memo_id?: number
}
export async function apiDDPlanRollback(params: IDDPlanRollbackParams) {
  return request('/api/v2/project/pipeline/dd/plan/sponsor_rollback', {
    method: 'POST',
    data: params
  })
}
export interface ISponsorRollbackParams {
  spa_id?: number
  spa_status?: number
}
export async function apiSpaSponsorRollback(params: ISponsorRollbackParams) {
  return request('/api/v2/project/pipeline/spa/sponsor_rollback', {
    method: 'POST',
    data: params
  })
}
export interface ITsSponsorRollbackParams {
  memo_id?: number
  ts_status?: number
}
export async function apiTsSponsorRollback(params: ITsSponsorRollbackParams) {
  return request('/api/v2/project/pipeline/ts/sponsor_rollback', {
    method: 'POST',
    data: params
  })
}
export interface IPaymentLegalConfirmParams {
  id?: number
}
export async function apiPaymentLegalConfirm(params: IPaymentLegalConfirmParams) {
  return request('/api/v2/project/pipeline/payment/legal_confirm', {
    method: 'POST',
    data: params
  })
}
export interface IPaymentLegalRollbackParams {
  id?: number
}
export async function apiPaymentLegalRollback(params: IPaymentLegalRollbackParams) {
  return request('/api/v2/project/pipeline/payment/legal_rollback', {
    method: 'POST',
    data: params
  })
}
export interface IPaymentSponsorRollbackParams {
  id?: number
  payment_status?: number
}
export async function apiPaymentSponsorRollback(params: IPaymentSponsorRollbackParams) {
  return request('/api/v2/project/pipeline/payment/sponsor_rollback', {
    method: 'POST',
    data: params
  })
}
